module.exports = __webpack_public_path__ + "img/history-2.a71dac72.png";